import jsdk from '../../jsdk';
import t from 'tcomb';
import Arr_Schema from './Arr_Schema';
import Component_Option from './Component_Option';
import Checkboxes_Style from './style/Checkboxes_Style';
import Checkboxes_Other from './Checkboxes_Other';
import getUUID from '../../getUUID';
import assign from 'lodash/object/assign';
import shuffle from 'lodash/collection/shuffle';

const Ord = t.enums.of(['asc', 'desc', 'random']);

const Checkboxes_Component = t.struct({
  name: t.Str,
  style: Checkboxes_Style,
  options: t.list(Component_Option),
  schema: Arr_Schema,
  other: t.maybe(Checkboxes_Other),
  order: t.maybe(Ord),
  other_label: t.maybe(t.String)
}, 'Checkboxes_Component');


Checkboxes_Component.prototype.to_form = function() {

  function getOption(option) {
    return [option.k, option.v, option.is_exclusive];
  }

  const getOptionsOrdered = () => {
    const options = this.options.map(getOption);

    if (this.order !== null) {
      if (this.order === 'random') {
        return shuffle(options);
      } else {
        return options.sort(jsdk.by(1, this.order === 'desc'));
      }
    } else {
      return options;
    }
  };

  return assign({}, this, {
    id: getUUID(), // id temporaneo utile alla Form
    type: 'reducer/checkboxes',
    options: getOptionsOrdered(),
    other_label: this.other_label
  });
};

export default Checkboxes_Component;



/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/Checkboxes_Component.js
 **/